import { type FC, lazy, Suspense } from 'react';
import { useClientState } from 'dibs-react-hooks/exports/useClientState.ts';

const ZoomModal = lazy(
    () => import(/* webpackChunkName: "NftPdpZoomModal" */ './NftPdpZoomModal.tsx')
);

type Props = Parameters<typeof ZoomModal>[0];

export const NftPdpZoomModalLazy: FC<Props> = props => {
    const isClient = useClientState();
    return isClient ? (
        <Suspense fallback="">
            <ZoomModal {...props} />
        </Suspense>
    ) : null;
};
